let formModel = {
    locales: [],
    permissions:[]
}
export default formModel